import React from 'react';

export function WhyChoose() {
  const reasons = [
    { icon: '⚡', title: 'Instant & Convenient', desc: 'Ready in under 3 minutes — ideal for busy weekday mornings or on-the-go lifestyles.', accent: 'amber' },
    { icon: '🏋️', title: 'Nutrient Dense', desc: 'High in fibre and a natural source of protein to power your day from the first meal.', accent: 'green' },
    { icon: '🚫', title: 'Clean Ingredients', desc: 'Zero artificial additives. No refined sugar. Just honest, recognisable food.', accent: 'coral' },
    { icon: '🌿', title: '100% Vegetarian', desc: 'Suitable for vegetarians. Crafted with plant-based wholefood ingredients.', accent: 'green' },
    { icon: '🏠', title: 'Homemade Goodness', desc: 'Inspired by home kitchens, made with love and care in every batch.', accent: 'coral' },
    { icon: '🎯', title: 'Balanced Breakfast', desc: 'The perfect macronutrient balance — carbs, protein and healthy fats in one bowl.', accent: 'amber' },
  ];
  return (
    <section id="why-choose" className="section whychoose-section">
      <div className="container">
        <h2>More Than Just Breakfast</h2>
        <p className="section-intro">
          Kiane isn't just food — it's a commitment to starting every morning with intention and nourishment.
        </p>
        <div className="reasons-grid">
          {reasons.map(r => (
            <div className={`reason-card reason-card-${r.accent}`} key={r.title}>
              <div className="reason-icon">{r.icon}</div>
              <h3>{r.title}</h3>
              <p>{r.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
